export const formatQuantity = (quantity: number, unitLabel: string): string =>
  `${quantity.toLocaleString('en-GB', { maximumFractionDigits: 3 })} ${unitLabel}`;

export const formatUnitRate = (rate: number, unitLabel: string): string =>
  `£${rate.toLocaleString('en-GB', { maximumFractionDigits: 4 })} / ${unitLabel}`;
